import { render, staticRenderFns } from "./ProfileComments.vue?vue&type=template&id=11f24606&scoped=true"
import script from "./ProfileComments.vue?vue&type=script&lang=js"
export * from "./ProfileComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f24606",
  null
  
)

export default component.exports